import { mdiChevronRight } from '@mdi/js';
import Icon from '@mdi/react';
import WaitListLink from './WaitListLink';

function SectionFour() {
  return (
    <section className="flex flex-col p-8">
      <div className="flex flex-col items-center">
        <h2 className="text-3xl font-extrabold mb-4 text-center md:text-5xl">
          We Are <span className="text-gold">Revolutionizing</span>
          <br />
          The <span className="text-blue">EdTech</span> System!
        </h2>
        <div className="flex flex-col gap-5 items-center">
          <div className="flex flex-col items-center text-black-opaque-4 text-[10px] md:text-xl">
            <p className="text-center">
              Collaborate, Access Comprehensive &amp; Organized Course
              Materials,
            </p>
            <p className="text-center">
              Create Connections &amp; Build Communities With GartekCloude
            </p>
          </div>
          <div>
            <WaitListLink
              childEl={
                <button
                  type="button"
                  className="text-xs md:text-xl font-bold md:rounded-xl rounded-md text-white p-1 md:p-4 bg-gold flex gap-0.5 items-center"
                >
                  <span className="flex items-center">Join Wait List Now!</span>
                  <span className="flex items-center icon-container icon-container-medium">
                    <Icon path={mdiChevronRight} />
                  </span>
                </button>
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionFour;
